import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState<number>(0);
  const total = pageSamples.length;
  const goTo = (next: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(total - 1, next));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track || track.clientWidth === 0) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    if (current !== index) setIndex(current);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-123" data-mp="3pn81ai5o5b05">
      <div className="mx-auto max-w-5xl" data-id="element-124" data-mp="3kv6jyhtn8u39">
        <div className="mx-auto max-w-2xl text-center" data-id="element-125" data-mp="3ku59ofkgcbml">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-126" data-mp="1mm2slqwj4pbn">
            <span aria-hidden="true" data-id="element-127" data-mp="1rlywlq588gr7">👀 </span>Sfoglia il materiale
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-128" data-mp="1du0ysbgyu7ac">
            Guarda le pagine <span className="italic text-brand" data-id="element-129" data-mp="1hubc69737zz8">dall&apos;interno.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-130" data-mp="13utj3hmre0k2">
            Esempi reali dal pacchetto, dalla fattura elettronica del primo anno all&apos;analisi
            per indici del quinto.
          </p>
        </div>

        <div ref={trackRef} onScroll={handleScroll} role="group" aria-roledescription="carosello" aria-label="Pagine di esempio del materiale" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="no-scrollbar mt-10 flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain rounded-3xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-131" data-mp="ux9h26h2o08e">
          {pageSamples.map((page, pageIndex) => <article key={page.src} aria-roledescription="slide" aria-label={`${pageIndex + 1} di ${total}`} className="w-full min-w-0 shrink-0 snap-start" data-id="element-132" data-mp="orjqwz5qayho" data-mpi={pageIndex}>
              <div className="grid gap-6 md:grid-cols-2 md:items-center md:gap-8" data-id="element-133" data-mp="fyf2p1tmvvvp">
                <div className="relative min-w-0 overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:p-4" data-id="element-134" data-mp="b0x0rve1agx7">
                  <img src={page.src} alt={`${page.title} — pagina di esempio, ${page.level}`} loading={pageIndex === 0 ? 'eager' : 'lazy'} className="block h-auto w-full rounded-xl" data-id="element-135" data-mp="18ix4tkgs6ivl" />
                  <button type="button" onClick={() => goTo(pageIndex - 1)} aria-label="Pagina precedente" className="absolute left-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-6" data-id="element-136" data-mp="1g0v9nbo0p5sh">
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="23sa8gugl54yz" />
                  </button>
                  <button type="button" onClick={() => goTo(pageIndex + 1)} aria-label="Pagina successiva" className="absolute right-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-6" data-id="element-138" data-mp="2cqm63gfvd30x">
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="28tf3d8bf5vcu" />
                  </button>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-ink/85 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-140" data-mp="1l55hy7i4b9m8">
                    {pageIndex + 1} / {total}
                  </span>
                </div>

                <div className="min-w-0 md:pr-4" data-id="element-141" data-mp="36h70616keujw">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-142" data-mp="36fvz494i80wh">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-143" data-mp="nauw9giql47o">
                    {page.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-144" data-mp="s7l81rniddna">{page.caption}</p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-3 text-center text-xs font-bold tabular-nums text-ink/40" data-id="element-145" data-mp="j9jchrmjnd7e">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}